/**
 * The Providers
 */ 
export const Provider = {
  // The reducers
  _reducers: [],
  // The subscribe handlers
  _handlers: [],
  // the middlewares
  _middlewares: [],
  // The state manager
  _updateState: function(){}
}